import { DefaultRouteTabs } from '@/components/_common';
import { PageProps } from '@/types/PageProps';
import { useIntl } from 'react-intl';
import { workorderRoutes } from '../route';
import { Helmet } from 'react-helmet';
import WorkOrderIndicatorsQuantity from '@/components/Movements/WorkOrders/Indicators/WorkOrderIndicatorsQuantity';
import WorkOrderIndicatorsAmount from '@/components/Movements/WorkOrders/Indicators/WorkOrderIndicatorsAmount';
import WorkOrderIndicatorsChat from '@/components/Movements/WorkOrders/Indicators/WorkOrderIndicatorsChart';
import WorkOrderIndicatorsFilter from '@/components/Movements/WorkOrders/Indicators/WorkOrderIndicatorsFilter';
import { useState } from 'react';
import { Divider, Empty } from 'antd';
import { WorkOrderChartFilter } from '@/core/domain/workorder/WorkOrdersChart/WorkOrdersChart.types';
import { DateTimeFormat } from '@/utils/moment';
import WorkOrderIndicatorsItensAmount from '@/components/Movements/WorkOrders/Indicators/WorkOrderIndicatorsItensAmount';

import './style.less';

export default function WorkOrderIndicatorsPage({ route }: PageProps) {
  const intl = useIntl();

  const [filter, setFilter] = useState<WorkOrderChartFilter>();

  const newRoute = {
    ...route.parent,
    routes: [
      route.parent,
      ...route.parent.routes.filter((route) =>
        workorderRoutes.includes(route.key),
      ),
    ],
  };

  return (
    <>
      <DefaultRouteTabs route={newRoute} permissions={route.permissions}>
        <Helmet title={intl.formatMessage({ id: route.name })} />

        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
          <WorkOrderIndicatorsFilter
            onChage={(values) =>
              setFilter(
                values
                  ? {
                      ...values,
                      startDate: values?.startDate.format(DateTimeFormat),
                      endDate: values?.endDate.format(DateTimeFormat),
                    }
                  : undefined,
              )
            }
          />

          {!filter && (
            <Empty description="Preencha todos os campos obrigatórios do filtro" />
          )}

          <Divider />

          {!!filter && (
            <div className="workorder-indicator">
              <WorkOrderIndicatorsQuantity filter={filter} />

              <Divider />

              <WorkOrderIndicatorsAmount filter={filter} />

              <Divider />

              <WorkOrderIndicatorsItensAmount filter={filter} />

              <Divider />

              <WorkOrderIndicatorsChat filter={filter} />
            </div>
          )}
        </div>
      </DefaultRouteTabs>
    </>
  );
}
